import { Localization, type IPlayer, type ITeamInfo } from "../../types/types";

export type PlayerPosition = "TOP" | "JUNGLE" | "MID" | "BOTTOM" | "SUPPORT" | "FILL";

export type TeamTab = "roster" | "history" | "placements";

export const POSITION_ORDER: Record<string, number> = {
  TOP: 1,
  JUNGLE: 2,
  MID: 3,
  BOTTOM: 4,
  ADC: 4,
  SUPPORT: 5,
  FILL: 6,
};

export const ROLE_ICONS: Record<PlayerPosition, string> = {
  TOP: "https://static.wikia.nocookie.net/leagueoflegends/images/e/ef/Top_icon.png",
  JUNGLE: "https://static.wikia.nocookie.net/leagueoflegends/images/1/1b/Jungle_icon.png",
  MID: "https://static.wikia.nocookie.net/leagueoflegends/images/9/98/Middle_icon.png",
  BOTTOM: "https://static.wikia.nocookie.net/leagueoflegends/images/9/97/Bottom_icon.png",
  SUPPORT: "https://static.wikia.nocookie.net/leagueoflegends/images/e/e0/Support_icon.png",
  FILL: "https://raw.communitydragon.org/latest/plugins/rcp-fe-lol-clash/global/default/assets/images/position-selector/positions/icon-position-fill.png",
};

export const MOBILE_CHAMP_PREVIEW = 3;

export const sortPlayersByPosition = (players: IPlayer[]): IPlayer[] =>
  [...players].sort((a, b) => {
    const weightA = POSITION_ORDER[a.position.toUpperCase()] || 99;
    const weightB = POSITION_ORDER[b.position.toUpperCase()] || 99;
    return weightA - weightB;
  });

export const isPrimaryPlayer = (player: IPlayer): boolean =>
  player.playerType.toUpperCase() !== "SUBSTITUTE";

export const teamDescription = (team: ITeamInfo, localization: Localization): string => {
  const value = localization === Localization.Finnish ? team.description_fin : team.description_en;
  return String(value ?? "").trim();
};

export const formatSeasonLabel = (season: string) => season.replace("-", " ");

export const placeLabel = (place: number, copy: { PLACE: string; PLACE_NA: string }) => {
  if (!place) return copy.PLACE_NA;
  return copy.PLACE.replace("{place}", String(place));
};

export const rankedCrestUrl = (tier: string) =>
  `https://raw.communitydragon.org/latest/plugins/rcp-fe-lol-static-assets/global/default/images/ranked-mini-crests/${tier}.svg`;

/** Numeric champion id → Community Dragon icon (not for names — use utils/championStats). */
export const championIconById = (championId: number | string) =>
  `https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/${String(championId)}.png`;
